const sticky = {
  stuckClass: "activeClass",

  init() {
    this.setStickyClass();
  },

  setStickyClass() {
    const onScroll = () => {
      const els = document.querySelectorAll(".jsStickyLine") as NodeListOf<HTMLElement>;
      const header = document.getElementById('jsStickyHeader') as HTMLElement;
      els.forEach((el) => {
        const stickyTop = parseFloat(getComputedStyle(el).top) || 0;
        const rect = el.getBoundingClientRect();
        const isStuck = rect.top <= stickyTop + 1;

        el.classList.toggle(this.stuckClass, isStuck);
        header?.classList.toggle(this.stuckClass, isStuck);
      }); 
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  },
};

export default sticky;